<template>
  <div class="translations-modal__overlay" @click.self="$emit('close')">
    <div class="translations-modal">
      <div class="translations-modal__header">
        <h3>Traduções — {{ ferramentaNome }}</h3>
        <button class="translations-modal__close" @click="$emit('close')">&times;</button>
      </div>

      <div v-if="loading" class="translations-modal__loading">Carregando traduções...</div>

      <div v-else class="translations-modal__grid">
        <div
          v-for="lang in langs"
          :key="lang.code"
          class="translations-modal__lang"
        >
          <div class="translations-modal__lang-header">
            <span class="translations-modal__lang-label">{{ lang.label }}</span>
            <span
              v-if="!lang.conteudo"
              class="translations-modal__badge translations-modal__badge--missing"
            >Sem tradução</span>
            <span
              v-else
              class="translations-modal__badge translations-modal__badge--ok"
            >OK</span>
          </div>
          <div class="translations-modal__lang-content" v-html="lang.conteudo || '<em>Nenhum conteúdo</em>'"></div>
        </div>
      </div>

      <div class="translations-modal__footer">
        <button class="translations-modal__btn" @click="$emit('close')">Fechar</button>
      </div>
    </div>
  </div>
</template>

<script>
import { ref, onMounted } from 'vue';
import api from '@/api';

export default {
  name: 'TranslationsModal',
  props: {
    ferramentaId: { type: [Number, String], required: true },
    ferramentaNome: { type: String, default: '' },
  },
  emits: ['close'],
  setup(props) {
    const loading = ref(false);
    const langs = ref([
      { code: 'pt', label: 'Português', conteudo: null },
      { code: 'en', label: 'English', conteudo: null },
      { code: 'es', label: 'Español', conteudo: null },
      { code: 'nl', label: 'Nederlands', conteudo: null },
    ]);

    const loadTranslations = async () => {
      loading.value = true;
      try {
        // Primeiro precisamos encontrar o "nome" da ferramenta base para buscar em cada idioma
        const baseRes = await api.getToolById(props.ferramentaId);
        const baseName = baseRes.data?.nome;

        for (const lang of langs.value) {
          try {
            // Buscar a ferramenta nesse idioma pelo nome
            const searchRes = await api.searchTools({ nome: baseName, idioma: lang.code });
            const tool = (searchRes.data || []).find(t => t.nome === baseName && t.idioma === lang.code);
            if (tool) {
              const versaoRes = await api.getConteudoVersoesPorFerramenta(tool.id, lang.code);
              if (versaoRes.data && versaoRes.data.length > 0) {
                lang.conteudo = versaoRes.data[0].conteudo || null;
              }
            }
          } catch {
            // idioma não tem essa ferramenta
          }
        }
      } catch (err) {
        console.error('Erro ao carregar traduções:', err);
      } finally {
        loading.value = false;
      }
    };

    onMounted(loadTranslations);

    return { loading, langs };
  },
};
</script>

<style scoped>
.translations-modal__overlay {
  position: fixed;
  inset: 0;
  background: rgba(0,0,0,0.4);
  z-index: 9000;
  display: flex;
  align-items: center;
  justify-content: center;
}

.translations-modal {
  background: #fff;
  border-radius: 8px;
  width: 95vw;
  max-width: 1200px;
  max-height: 85vh;
  display: flex;
  flex-direction: column;
  box-shadow: 0 8px 30px rgba(0,0,0,0.2);
}

.translations-modal__header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 16px 20px;
  border-bottom: 1px solid #eee;
}

.translations-modal__header h3 { margin: 0; font-size: 17px; }

.translations-modal__close {
  background: none;
  border: none;
  font-size: 24px;
  cursor: pointer;
  color: #666;
}

.translations-modal__loading {
  padding: 40px;
  text-align: center;
  color: #888;
}

.translations-modal__grid {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 16px;
  padding: 16px 20px;
  overflow-y: auto;
  flex: 1;
}

.translations-modal__lang {
  border: 1px solid #e0e0e0;
  border-radius: 4px;
  overflow: hidden;
}

.translations-modal__lang-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 8px 12px;
  background: #f5f6f8;
  border-bottom: 1px solid #e0e0e0;
  font-size: 13px;
  font-weight: 600;
}

.translations-modal__lang-label { color: #333; }

.translations-modal__badge {
  font-size: 11px;
  font-weight: 600;
  padding: 2px 8px;
  border-radius: 10px;
}

.translations-modal__badge--missing {
  background: #fce8e6;
  color: #d93025;
}

.translations-modal__badge--ok {
  background: #e6f4ea;
  color: #188038;
}

.translations-modal__lang-content {
  padding: 10px 12px;
  font-size: 13px;
  line-height: 1.5;
  color: #444;
  max-height: 250px;
  overflow-y: auto;
}

.translations-modal__footer {
  padding: 14px 20px;
  border-top: 1px solid #eee;
  display: flex;
  justify-content: flex-end;
}

.translations-modal__btn {
  padding: 8px 20px;
  font-size: 13px;
  background: #f0f0f0;
  border: 1px solid #ccc;
  border-radius: 4px;
  cursor: pointer;
}

.translations-modal__btn:hover { background: #e0e0e0; }

@media (max-width: 768px) {
  .translations-modal__grid {
    grid-template-columns: 1fr;
  }
}
</style>
